import { css } from '@emotion/css'

export const styles = {
  button: css`
    padding: 0;
    min-width: 2.7rem;
  `,
}
